import { Injectable } from "@angular/core";
import { Store } from "@ngrx/store";
import { Observable } from "rxjs";
import { AppState } from "src/app/shared/store/app.state";
import {
  BMIConstraints,
  EntryAgeConstraints,
  InsuredSumConstraints,
  ProductConstraints,
  ProductConstraintsService,
  YearlyPremiumConstraints,
} from "src/app/shared/store/quote/product-constraints.factory";
import {
  selectBmiConstraints,
  selectEntryAgeConstraints,
  selectInsuredSumConstraints,
  selectProductConstraints,
} from "src/app/shared/store/quote/term-life-insurance/quote.selectors";

@Injectable({
  providedIn: "root",
})
export class TermLifeInsuranceProductConstraintsService
  implements ProductConstraintsService
{
  constructor(private readonly _store: Store<AppState>) {}

  get(): Observable<ProductConstraints> {
    return this._store.select(selectProductConstraints);
  }

  getInsuredSumConstraints(): Observable<InsuredSumConstraints> {
    return this._store.select(selectInsuredSumConstraints);
  }

  getEntryAgeConstraints(): Observable<EntryAgeConstraints> {
    return this._store.select(selectEntryAgeConstraints);
  }

  getBmiConstraints(): Observable<BMIConstraints> {
    return this._store.select(selectBmiConstraints);
  }

  getYearlyPremiumConstraints(): Observable<YearlyPremiumConstraints> {
    throw new Error(
      "Method not implemented. Term Life Insurance doesn't have yearly premium constraints.",
    );
  }

  getMaximumCoverageAge(): Observable<number | undefined> {
    throw new Error(
      "Method not implemented. Pillar 3a doesn't have maximum coverage age.",
    );
  }
}
